import { Component, HostListener, OnInit } from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { USER_PROFILE } from "../../../../_models/user.model";
import { AuthService } from "../../../../_auth/auth.service";
import { AppSettingService } from "../../../../_services/_appSetting/app-setting.service";
import { LocalService } from "../../../../_services/_storage/local.service";
import { SUPPORT } from "../../../../_constants/support";
import { LOCALSTORAGEKEYS } from "../../../../_constants/localStorageKeys";
import { AppRole, RoleService } from "../../../../_services/_role/role.service";
import { SidebarService } from "../../../../_services/_sidebar/sidebar.service";

@Component({
  selector: "lokos-header",
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.scss",
  standalone: false,
})
export class HeaderComponent implements OnInit {
  theme!: string;
  userProfile: USER_PROFILE | any = null;
  isLoggedIn = false;
  isProduction = environment.production;

  menuOpen = false;
  rolesOpen = false;
  supportOpen = false;
  profileImageSrc = "assets/images/profileLogo.svg";
  availableRoles: AppRole[] = [];
  selectedRole: AppRole | null = null;
  canSwitchRole = false;

  constructor(
    private appSettingService: AppSettingService,
    private localService: LocalService,
    private authService: AuthService,
    private roleService: RoleService,
    public sidebar: SidebarService,
  ) {}

  ngOnInit(): void {
    this.isLoggedIn = this.authService.isLoggedIn();
    const stored = this.localService.get("userProfile");
    if (stored && this.isLoggedIn) {
      this.userProfile = stored;
    }
    this.appSettingService.appTheme$.subscribe(
      (themeValue) => (this.theme = themeValue),
    );
    this.availableRoles = this.roleService.availableRoles;
    this.selectedRole = this.roleService.selectedRole;
    this.canSwitchRole = this.roleService.canSwitch;
    const image = this.localService.get(LOCALSTORAGEKEYS.PROFILE_IMAGE) as
      | string
      | null;
    if (image) {
      this.profileImageSrc = `data:image/png;base64,${image}`;
    }
  }

  onBellClick(event: Event): void {
    event.stopPropagation();
  }

  toggleMenu(event: Event) {
    event.stopPropagation();
    this.menuOpen = !this.menuOpen;
    if (!this.menuOpen) {
      this.rolesOpen = false;
      this.supportOpen = false;
    }
  }

  toggleRoles(event: Event) {
    event.stopPropagation();
    if (!this.canSwitchRole) {
      return;
    }
    this.rolesOpen = !this.rolesOpen;
  }

  toggleSupport(event: Event) {
    event.stopPropagation();
    this.supportOpen = !this.supportOpen;
  }

  onSelectRole(role: AppRole, event: Event) {
    event.stopPropagation();
    this.menuOpen = false;
    this.roleService.switchRole(role);
  }

  onTicketSupport(event: Event) {
    event.stopPropagation();
    window.open(SUPPORT.TICKET_URL, "_blank", "noopener,noreferrer");
  }

  onEmailSupport(event: Event) {
    event.stopPropagation();
    window.location.href = `mailto:${SUPPORT.EMAIL}`;
  }

  @HostListener("document:click")
  closeMenu() {
    this.menuOpen = false;
    this.rolesOpen = false;
    this.supportOpen = false;
  }

  onLogout() {
    this.authService.logout();
  }
}
